import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/pipelines/$pipelineId/submissions/$submissionId/',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/pipelines',
      search: {
        order: 'desc',
        sort: 'created',
        status: ['active'],
      },
    });
  },
});
